import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Button, { ILink } from 'tbk-components/src/components/Button';

export interface ITeamMember {
	/**
	 * Team Member Image  - Image should be 196px X 196px
	 */
	image?: IImage;
	/**
	 * Team Member Full Name
	 */
	fullname?: string;
	/**
	 * Team Member Position
	 */
	position?: string;
	/**
	 * Team Member Link to Bio Page (Optional)
	 */
	link?: ILink;
}

export interface ITeamModuleProps extends IBaseElementProps {
	members?: ITeamMember[];
}

/**
 * Team Module
 * @block
 * @requiresHooks
 * @icon groups
 */
const TeamModule: React.FC<ITeamModuleProps> = ({
	className,
	classNames = [],
	members = [],
}) => (
	<div className={className || cn('team-module', ...classNames)}>
		{members.map(({ image, fullname, position, link }, index) => (
			<div className="team-module__member" key={index}>
				<div className="team-module__member__image-container">
					<Image {...image} className="team-module__member__image" />
				</div>
				<div className="team-module__member__info">
					<h3 className="team-module__member__name">{fullname}</h3>
					<div className="team-module__member__position">
						{position}
					</div>
					<Button className="team-module__member__link" {...link} />
				</div>
			</div>
		))}
	</div>
);

export default TeamModule;
